import { render, staticRenderFns } from "./BibliographyTagInput.vue?vue&type=template&id=741fbd4c&"
import script from "./BibliographyTagInput.vue?vue&type=script&lang=ts&"
export * from "./BibliographyTagInput.vue?vue&type=script&lang=ts&"
import style0 from "./BibliographyTagInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports